import React from "react";
import { Link } from "react-router-dom";

export default function ProfileCard({ profile, accent = "blue", isFavorite, onToggleFavorite }) {
  const accentClasses = accent === "teal"
    ? { btn: "btn-primary-teal", outline: "btn-outline-teal", price: "text-teal-600" }
    : { btn: "btn-primary", outline: "btn-outline", price: "text-blue-600" };

  const photo = profile.photo_url || `https://api.dicebear.com/9.x/initials/svg?seed=${encodeURIComponent(profile.name)}`;

  return (
    <div className="kibli-card overflow-hidden flex flex-col animate-fade-in-up" data-testid={`profile-card-${profile.id}`}>
      <div className="relative aspect-[4/5] bg-slate-100 overflow-hidden">
        <img
          src={photo}
          alt={profile.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 badge-verified" title="Perfil verificado">
          <i className="fa-solid fa-circle-check text-green-500"></i>
        </div>
        {onToggleFavorite && (
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onToggleFavorite(profile.id); }}
            data-testid={`favorite-toggle-${profile.id}`}
            className={`absolute top-3 right-3 w-10 h-10 rounded-full flex items-center justify-center transition ${
              isFavorite ? "bg-red-500 text-white" : "bg-white/90 backdrop-blur text-slate-600 hover:text-red-500"
            }`}
          >
            <i className={`${isFavorite ? "fa-solid" : "fa-regular"} fa-heart`}></i>
          </button>
        )}
      </div>
      <div className="p-4 flex-1 flex flex-col gap-2">
        <h3 className="font-bold text-slate-900 truncate">{profile.name}</h3>
        <div className="text-sm text-slate-600 flex items-center gap-2">
          <span className="text-amber-500"><i className="fa-solid fa-star"></i></span>
          <span className="font-semibold text-slate-700">{Number(profile.rating || 0).toFixed(1)}</span>
          {!!profile.review_count && (
            <span className="text-slate-400 text-xs">({profile.review_count})</span>
          )}
          <span className="text-slate-400">·</span>
          <span className="flex items-center gap-1 truncate">
            <i className="fa-solid fa-location-dot text-slate-400"></i>
            <span className="truncate">{(profile.zonas && profile.zonas[0]) || profile.ciudad}, {profile.ciudad}</span>
          </span>
        </div>
        <div className={`font-bold ${accentClasses.price}`}>{profile.price_per_hour}€/h</div>
        <div className="flex gap-2 mt-2">
          <Link to={`/profiles/id/${profile.id}`} className={`flex-1 ${accentClasses.outline} px-3 py-2 text-sm`} data-testid={`view-profile-btn-${profile.id}`}>
            Ver perfil
          </Link>
          <Link to={`/messages/with/${profile.owner_id}`} className={`flex-1 ${accentClasses.btn} px-3 py-2 text-sm`} data-testid={`contact-btn-${profile.id}`}>
            Contactar
          </Link>
        </div>
      </div>
    </div>
  );
}
